import { Container, Stack } from "@mui/material";
import { ComponentHeader, TestimonialGrid } from "@/components/ui";
import { testimonials } from "@/constants";
import { PAGE_COPY } from "@/constants/pages";

export const Testimonials = () => {
  return (
    <Container maxWidth="lg">
      <Stack spacing={6} alignItems="center">
        <ComponentHeader
          title={PAGE_COPY.sections.testimonials.title}
          subTitle={PAGE_COPY.sections.testimonials.subTitle}
          component="h2"
        />
        <TestimonialGrid testimonials={testimonials} />
      </Stack>
    </Container>
  );
};
